module.exports = __webpack_public_path__ + "static/media/roasted.1cfbc6b4.jpg";